var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconOutlineBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71032 6.22315C8.02105 5.69426 7 6.16496 7 7.0116V12.9884C7 13.835 8.02105 14.3057 8.71032 13.7768L12.6049 10.7884C13.1317 10.3842 13.1317 9.61576 12.6049 9.21156L8.71032 6.22315Z",
    fill: "#5062F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconOutlineBlue);
export default __webpack_public_path__ + "static/media/playIconOutlineBlue.4ab3d4dc8ba6529f302eb0096e69769e.svg";
export { ForwardRef as ReactComponent };